import { Component, inject } from '@angular/core'
import { MaintenanceService } from './maintenance.service'

/**
 * Blocco full-screen per maintenance attiva con display=overlay.
 * Non chiudibile: sparisce solo quando il poll conferma che la maintenance
 * è terminata (o per gli utenti con bypass, che non lo vedono affatto).
 */
@Component({
  selector: 'fq-maintenance-overlay',
  standalone: true,
  template: `
    <div class="fq-moverlay" role="alertdialog" aria-modal="true">
      <div class="fq-moverlay-card" [style.border-top-color]="svc.bannerColor()">
        <div class="fq-moverlay-icon" aria-hidden="true">⛔</div>
        <h2 class="fq-moverlay-title">Manutenzione in corso</h2>
        @if (svc.state()?.message) {
          <p class="fq-moverlay-msg">{{ svc.state()?.message }}</p>
        }
        @if (svc.formatCountdown(); as countdown) {
          <div class="fq-moverlay-count">
            <small>Termine stimato tra</small>
            <b>{{ countdown }}</b>
          </div>
        }
        <div class="fq-moverlay-footer">
          <button type="button" class="fq-btn fq-btn-primary" (click)="svc.refreshNow()">Riprova ora</button>
          <small class="fq-moverlay-hint">
            @if (svc.reachable() === false) {
              Server non raggiungibile: nuovo tentativo automatico…
            } @else {
              L'accesso verrà ripristinato automaticamente al termine.
            }
          </small>
        </div>
      </div>
    </div>
  `
})
export class MaintenanceOverlayComponent {
  readonly svc = inject(MaintenanceService)
}
